







































import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { GapReportFilter } from "@/store/modules/types";

@Component({
  computed: mapState("gaps", ["insurers","campaigns"])
})
export default class ApptStatusSearch extends Vue {
  @Model("change") readonly filter!: GapReportFilter;
}
